<template>
    <section>
        <div class="section-content" v-if="articleDetail">
            <div class="sc-head">
                <p class="small-title">{{ articleDetail.facility_name }}</p>
                <h1 class="main-title" id="index-h1-0">
                    <strong>{{ articleDetail.name }}</strong>
                </h1>
            </div>
            <div class="sc-inner">
                <div class="sci-left">
                <div class="sh-image">
                    <img :src="articleDetail.thumbnail_url" alt="promo"/>
                </div>
                    <div class="sl-head">
                    </div>
                    <div class="sl-body">
                        <div class="sl-order" v-if="articleDetail.cta.fullUrl">
                            <a :href="articleDetail.cta.fullUrl" target="_blank">Order Sekarang</a>
                        </div>
                        <div class="sl-content ql-container ql-snow" style="position: relative;">
                            <div class="sl-content-text ql-editor" id="sl-content-text">
                                <div class="sct-text" v-html="articleDetail.content"></div>
                                <div class="contact" v-if="articleDetail.facility_name">
                                    <h2>Cara Mendapatkan Layanan Ini</h2>
                                    <br/>
                                    <p>Untuk informasi lebih lanjut atau untuk membuat janji konsultasi, Anda dapat menghubungi kami di:</p>
                                    <br/>
                                    <div class="contact-head">
                                        <h3>{{ articleDetail.facility_name }}</h3>
                                    </div>
                                    <div class="contact-row">
                                        <div class="contact-row-param">
                                            <span>Whatsapp</span>
                                        </div>
                                        <div class="contact-row-value crv-button">
                                            <span><a :href="`https://api.whatsapp.com/send/?phone=${articleDetail.facility_phone}&text=Halo, ${articleDetail.facility_name}!`" target="_blank">{{ articleDetail.facility_phone }}</a></span>
                                        </div>
                                    </div>
                                    <div class="contact-row">
                                        <div class="contact-row-param">
                                            <span>Alamat</span>
                                        </div>
                                        <div class="contact-row-value">
                                            <span>{{ articleDetail.facility_address }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="sci-right">
                    <div class="sr-others">
                        <div class="sr-title">{{ articleDetail.data_doctor?.name }}</div>
                        <div class="sr-others-inner">
                            <div class="soi-image" v-if="articleDetail.data_doctor?.profile">
                                <img :src="articleDetail.data_doctor?.profile" :alt="articleDetail.data_doctor.name"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <PromoDetailSkeleton v-else/>
    </section>
</template>

<script setup>
    import PromoDetailSkeleton from "../skeletons/PromoDetailSkeleton.vue";
    import { usePromoStore } from "../../stores/promo";
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    import { useRoute } from 'vue-router';
    import { computed } from "@vue/runtime-core";
    const articleDetail = computed(() => usePromoStore().articleDetail);
    usePromoStore().setArticleDetail(useRoute().params.slug);
</script>

<style scoped>
    @import url('../../assets/css/ql-editor.css');
    @import url('../../assets/css/article_detail_index.css');
    @import url('../../assets/css/promos/promo-detail.css');
</style>